module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sale":"Sale","new":"New","quickView":"Quick view","moreColors":"More colours","add":"Add item to wishlist","addToCart":"Add to Bag"},"de":{"sale":"Sale","new":"Neu","quickView":"Schnellansicht","moreColors":"Mehr Farben","add":"Auf den Wunschzettel","addToCart":"Zum Warenkorb Hinzufügen"}}')
  delete Component.options._Ctor
}
